<template>
  <v-container>
    <v-row align="start">
      <!-- ===== HEADER ===== -->
      <v-col cols="12">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="text-xl-h4 text-lg-h5 font-weight-bold">
            {{ $t('Dashboard.Header.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-slide-x-transition>
          <QlikSelections v-show="!showTools" :apps="apps"/>

          </v-slide-x-transition>
          <v-speed-dial
            v-model="showTools"
            direction="left"
            transition="slide-x-reverse-transition"
          >
            <template v-slot:activator>
              <v-btn icon color="secondary" fab>
                <v-icon>settings</v-icon>
              </v-btn>
            </template>
            <!-- <v-btn color="secondary" rounded outlined @click="showSettings = true">
              <v-icon left>tune</v-icon>
              Paramètres
            </v-btn> -->
            
            <v-btn color="secondary" rounded outlined @click="showPresets = true">
              <v-icon left>collections_bookmark</v-icon>
              {{$t('Dashboard.Tools.templates')}}
            </v-btn>
            <v-btn v-if="isAdmin && template && slots" color="secondary" rounded outlined @click="creatingPreset = true">
              <v-icon left>bookmark_add</v-icon>
              {{$t('Dashboard.Tools.saveAsTemplate')}}
            </v-btn>
          </v-speed-dial>
        </v-toolbar>
      </v-col>

      <v-col cols="12">
        <DashboardRender v-if="template && slots" :template="template" :slots="slots"/>
      </v-col>
    </v-row>
    <v-dialog
      v-model="creatingPreset"
      max-width="800"
    >
      <DashboardPresetsNew @created="creatingPreset = false"/>
    </v-dialog>
    <v-dialog
      v-model="showPresets"
      max-width="800"
    >
      <DashboardPresets @selected="showPresets = false"/>
    </v-dialog>
    <HelpGetStarted 
      :show="showGetStarted"
      @finish="showGetStarted = false"
    />
    <DashboardSlotEditor />
  </v-container>
</template>

<script>

import DashboardSlotEditor from '@/components/Dashboard/DashboardSlotEditor'
import DashboardRender from '@/components/Dashboard/DashboardRender'
import DashboardPresets from '@/components/Dashboard/DashboardPresets'
import DashboardPresetsNew from '@/components/Dashboard/DashboardPresetsNew'
import { mapActions, mapGetters, mapState } from 'vuex'
import QlikSelections from '@/components/Qlik/QlikSelections'
import HelpGetStarted from '@/components/Help/HelpGetStarted'

export default {
  components: { DashboardRender, DashboardPresets, DashboardPresetsNew, DashboardSlotEditor, QlikSelections, HelpGetStarted },
  data: () => ({
    showTools: false,
    showPresets: false,
    showGetStarted: false,
    showSettings: false,
    creatingPreset: false,
    isLeaving: false
  }),
  computed: {
    ...mapGetters('dashboard', [
      'template',
      'slots'
    ]),
    ...mapGetters('auth', [
      'isAdmin'
    ]),
    ...mapState('auth', [
      'user'
    ]),
    ...mapState('qlik', [
      'apps'
    ])
  },
  methods: {
    ...mapActions('dashboard', [
      'setup'
    ])
  },
  created () {
    this.setup(this.user.dashboard)
  },
  mounted () {
    if (!this.template || !this.slots) {
      this.showPresets = true
      this.showGetStarted = true
    }
  }
}
</script>

